// const apiUrl = "https://bus-sheet.shipces.net/backend/api/"
const apiUrl = process.env.REACT_APP_API_URL;
console.log(apiUrl)
export { apiUrl };